// extracted by mini-css-extract-plugin
module.exports = {"loggedInContainer":"LoggedInBox_loggedInContainer__3Kh2Z","loggedInMessage":"LoggedInBox_loggedInMessage__yGJq6","loggedInEmail":"LoggedInBox_loggedInEmail__Ps6-6"};